// @flow

import { observable, action, runInAction } from "mobx"
import FleetGateway from "shared/apis/FleetGateway"
import find from "lodash/find"

class BrandsStore {
  @observable brands: Array<Object> = []
  @observable isLoadingBrands: boolean = false

  @action
  async getFleetBrands() {
    if (this.brands.length === 0) {
      runInAction(() => (this.isLoadingBrands = true))

      try {
        const result = await FleetGateway.brands.getFleetBrands()

        runInAction(
          () =>
            (this.brands = (result && result.data && result.data.brands) || [])
        )
      } finally {
        runInAction(() => (this.isLoadingBrands = false))
      }
    }
  }

  getBrandById(id: number): any {
    return find(this.brands, brand => brand.id === id)
  }
}

export default (new BrandsStore(): BrandsStore)
